import PlanService, {PlanConst} from "app/plan/model/plan";
import SnapService, {SnapConst} from "app/plan/snap.service";
import TableHelpersService from "app/services/tableHelpers.service";
import TableLabelService from "app/services/tableLabel.service";
import FloorplanFilterService from "app/services/floorplanFilter.service";
import PlanBookingService from "app/plan/model/booking";
import PlanStructureService from "app/plan/model/structure";
import PlanGroupService from "app/plan/model/group";
import PlanTableService from "app/plan/model/table";
import PlanDividerService from "app/plan/model/divider";
import PlanDoorService from "app/plan/model/door";
import PlanFrameService from "app/plan/model/frame";
import PlanTextOnlyService from "app/plan/model/textOnly";
import PlanSectionService from "app/plan/model/section";
import PlanCommandService from "app/plan/model/command";
import PlanLayoutService from "app/plan/model/layout";
import PlanMementoService from "app/plan/model/memento";

/**
 * Provides assets needed for the floorplan module, but doesn't actually create the module.
 * This alllows it to be used for unit tests as well, when mocking the floorplan easily.
 */

interface IMapPair {
  name: string;
  value: any;
}

export const floorplanServiceMap: IMapPair[] = [
  {name: 'Plan', value: PlanService},
  {name: 'SnapService', value: SnapService},
  {name: 'tableHelpersService', value: TableHelpersService},
  {name: 'tableLabelService', value: TableLabelService},
  {name: 'floorplanFilterService', value: FloorplanFilterService},
  {name: 'Booking', value: PlanBookingService},
  {name: 'Structure', value: PlanStructureService},
  {name: 'Group', value: PlanGroupService},
  {name: 'Table', value: PlanTableService},
  {name: 'Divider', value: PlanDividerService},
  {name: 'Door', value: PlanDoorService},
  {name: 'Frame', value: PlanFrameService},
  {name: 'TextOnly', value: PlanTextOnlyService},
  {name: 'Section', value: PlanSectionService},
  {name: 'Command', value: PlanCommandService},
  {name: 'Layout', value: PlanLayoutService},
  {name: 'Memento', value: PlanMementoService},
];

export const floorplanConstantMap: IMapPair[] = [
  {name: 'PlanConst', value: PlanConst},
  {name: 'SnapConst', value: SnapConst}
];
